// extracted by mini-css-extract-plugin
module.exports = {"loader":"Expenses_loader__1_x5I","load3":"Expenses_load3__XaJOk"};